/*
 * @Descripttion:
 * @Author: voanit
 * @Date: 2021-02-04 09:43:09
 * @LastEditors: sjq
 * @LastEditTime: 2021-03-17 13:52:22
 */
import store from '@/store'
/**
 * @param {Array} value
 * @returns {Boolean}
 * @example see @/views/permission/directive.vue
 */
export default function checkPermission(value) {
  // if (value && value instanceof Array && value.length > 0) {
  //   const roles = store.getters && store.getters.roles
  //   const permissionRoles = value

  //   const hasPermission = roles.some(role => {
  //     return permissionRoles.includes(role)
  //   })

  //   if (!hasPermission) {
  //     return false
  //   }
  //   return true
  // } else {
  //   console.error(`need roles! Like v-permission="['admin','editor']"`)
  //   return false
  // }

  const roles = store.getters && store.getters.roles
  if (value) {
    const activeName = value
    const hasPermission = roles?.some(role => {
      return activeName === role.menuCode
    })
    if (!hasPermission) {
      return false
    }
    return true
  } else {
    throw new Error(`按钮权限配置举例：v-permission="utils"`)
  }
}
